
const transformToColumns = function (form, filterTag = false) {
    const themeColor = "#3DB8C5";
    const toDecimal = function (x) {
        let f = parseFloat(x);
        if (isNaN(f)) {
            return;
        }
        f = Math.round(x * 100) / 100;
        return f;
    };
    let columns = [];
    form.filter(item => item._type !== "tag" || filterTag).map(item => {
        let col = {
            ...item,
            title: item._name,
            field: item._key,
            width: item._width,
            titleAlign: "left",
            columnAlign: "left",
            isResize: true
        };
        let titleWidth = (col.title ? col.title.length * 16 : 36) + 40;
        if (["text", "textarea"].includes(col._type)) {
            col.width = col._width || 200;
            col.titleAlign = "left";
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                if (params.row[col._key]) {
                    return h("Ctooltip", {
                        props: {
                            placement: "top",
                            transfer: true,
                            maxWidth: "200",
                            content: params.row[col._key]
                        },
                        style: {
                            width: "100%"
                        }
                    }, [
                        h("span", {
                            class: "dsh-ellipsis"
                        }, params.row[col._key])
                    ]);
                } else {
                    return h("span", "");
                }
            };
        } else if (["idcard", "email", "phone", "serialNumber"].includes(col._type)) {
            // 205, 110, 165
            if (["idcard"].includes(col._type)) {
                col.width = col._width || 190;
            } else if (["serialNumber"].includes(col._type)) {
                col.width = col._width || 140;
            } else if (["email"].includes(col._type)) {
                col.width = col._width || 200;
            } else {
                col.width = col._width || 130;
            }
            col.columnAlign = "left";
            col.formatter = (row, index) => {
                return row[col._key] && `<i class="dsh-margin-right5"></i>${row[col._key]}`;
            };
        } else if (["number"].includes(col._type)) {
            col.title = `${col.title}${col._unit && (" (" + col._unit + ")") || ""}`;
            col.width = col._width || 120;
            col.columnAlign = "right";
            col.titleAlign = col._titleAlign || "right";
            col.orderBy = "";
            col.componentName = "dsh-td-render";
            if (col._numberFormat == "percent") {
                col.render = (h, params) => {
                    let content = "";
                    if (params.row[col._key] != undefined) {
                        content = `${params.row[col._key]}%`;
                    }
                    return h("Ctooltip", {
                        props: {
                            placement: "top",
                            transfer: true,
                            content: String(content)
                        },
                        style: {
                            // width: "100%"
                        }
                    }, [
                        h("span", {
                            class: "dsh-ellipsis"
                        }, content)
                    ]);
                };
            } else if (col._separator) {
                col.render = (h, params) => {
                    let content = "";
                    if (params.row[col._key] != undefined) {
                        content = String(params.row[col._key]).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                    if (params.row[col._key]) {
                        return h("Ctooltip", {
                            props: {
                                placement: "top",
                                transfer: true,
                                content
                            },
                            style: {
                                width: "100%"
                            }
                        }, [
                            h("span", {
                                class: "dsh-ellipsis"
                            }, String(content))
                        ]);
                    } else {
                        return h("span", "");
                    }
                };
            } else {
                col.render = (h, params) => {
                    return h("Ctooltip", {
                        props: {
                            placement: "top",
                            transfer: true,
                            content: params.row[col._key] === 0 ? "0" : params.row[col._key] && String(params.row[col._key]) || ""
                        },
                        style: {
                            // width: "100%"
                        }
                    }, [
                        h("span", {
                            class: "dsh-ellipsis"
                        }, params.row[col._key] === 0 ? 0 : params.row[col._key] || "")
                    ]);
                };
            }
            if (col._showProgress) {
                col.render = (h, params) => {
                    return h("Progress", {
                        props: {
                            percent: params.row[col._key] > 100 ? 100 : toDecimal(params.row[col._key]),
                            textInside: true,
                            strokeWidth: 20
                        },
                        style: {
                            lineHeight: "20px",
                            width: "100%",
                            overflow: "hidden"
                        }
                    });
                };
            }
        } else if (["date"].includes(col._type)) {
            switch (col._dateType) {
            case "date": col.width = col._width || 120; break;
            case "year": col.width = col._width || 96; break;
            case "month": col.width = col._width || 120; break;
            case "time": col.width = col._width || 120; break;
            case "datetime": col.width = col._width || 180; break;
            default: col.width = col._width || 120; break;
            }
            col.columnAlign = "center";
            col.titleAlign = "center";
            col.orderBy = "";
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                let content = params.row[col._key];
                content = col._formate && content ? this.$dateFormat(content, col._formate) : content;
                return h("Ctooltip", {
                    props: {
                        content,
                        transfer: true
                    }
                }, [
                    h("div", {
                        class: "dsh-ellipsis"
                    }, content)
                ]);
            };
        } else if (["switch"].includes(col._type)) {
            col.width = col._width || 80;
            col.columnAlign = "center";
            col.titleAlign = "center";
            col.formatter = (row, index) => {
                return row[col._key] == undefined ? null : row[col._key] === false ? col._closeText : col._openText;
            };
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                return h("i-switch", {
                    props: {
                        size: "small",
                        disabled: true,
                        value: params.row[col._key]
                    },
                    style: {
                        textAlign: "center"
                    }
                });
            };
        } else if (["select"].includes(col._type)) {
            col.width = col._width || 120;
            col.columnAlign = "center";
            col.titleAlign = "center";
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                let data = (col._data.find(item => item._key === params.row[col._key]) || {});
                if (data.name || params.row[col._key]) {
                    return h("Ctooltip", {
                        props: {
                            placement: "top",
                            transfer: true,
                            content: data.name || params.row[col._key]
                        },
                        style: {
                            display: "flex",
                            alignItems: "center",
                            width: "100%"
                        }
                    }, [
                        h("div", {style: {
                            width: "100%"
                        }}, [
                            h("span", {
                                style: {
                                    backgroundColor: col._useColor ? data.color : "",
                                    color: col._useColor ? "#fff" : ""
                                },
                                class: "table-select-common dsh-ellipsis"
                            }, data.name || params.row[col._key])
                        ])
                    ]);
                }
            };
        } else if (["checkbox"].includes(col._type)) {
            col.componentName = "dsh-td-render";
            col.width = col._width || 180;
            col.render = (h, params) => {
                if (col._data && params.row[col._key]) {
                    let colArr = col._data.filter(item => params.row[col._key].includes(item._key));
                    return h("div", {
                        style: {
                            display: "flex",
                            overflow: "hidden"
                        }
                    }, [
                        ...colArr.map(item => {
                            return h("Ctooltip", {
                                props: {
                                    placement: "top",
                                    transfer: true,
                                    content: item.name
                                },
                                style: {
                                    minWidth: "35px",
                                    marginLeft: "3px"
                                }
                            }, [
                                h("div", {
                                    style: {
                                        background: col._useColor ? item.color : "",
                                        color: col._useColor ? "#fff" : ""
                                    },
                                    class: "table-select-common dsh-ellipsis"
                                }, item.name
                                )
                            ]);
                        })
                    ]);
                } else {
                    return h("span", params.row[col._key]);
                }
            };
        } else if (["cascader", "region"].includes(col._type)) {
            col.width = col._type === "cascader" ? (col._width || 150) : (col._width || 212);
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                let content = this.$getTreeLinealDatas(params.row[col._key], col._type === "cascader" ? col._data : regionData, "name").join("/");
                return h("Ctooltip", {
                    props: {
                        content,
                        transfer: true
                    }
                }, [
                    h("div", {
                        class: "dsh-ellipsis"
                    }, content)
                ]);
            };
        } else if (["file", "image"].includes(col._type)) {
            col.width = col._width || 100;
            col.titleAlign = "center";
            col.columnAlign = "center";
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                return h("div", {
                    style: {
                        textAlign: "center"
                    }
                }, [
                    h("Icon", {
                        props: {
                            custom: col._fileType == "file" ? "bico-font bico-file" : "bico-font bico-img"
                        },
                        class: "table-icon-common dsh-margin-right5"
                    }),
                    h("span", {
                        class: "table-text-common"
                    }, col._fileType == "file" ? `${params.row[col._key] ? params.row[col._key].length : 0}个`
                    : `${params.row[col._key] ? params.row[col._key].length : 0}张`)
                ]);
            };
        } else if (["flatTable", "cascaderTable"].includes(col._type)) {
            col.width = col._width || 100;
            col.columnAlign = "center";
            col.titleAlign = "center";
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                return h("div", {style: {
                    width: "100%",
                    overflow: "hidden"
                }}, [h("span", {
                    style: {
                        display: "inline-block",
                        height: "24px",
                        lineHeight: "24px",
                        padding: "0 5px",
                        margin: "auto",
                        background: "rgba(96, 144, 237, 0.15)",
                        borderRadius: "12px",
                        textAlign: "center",
                        color: themeColor
                    }
                }, [
                    h("Icon", {
                        props: {
                            custom: col._type == "cascaderTable" ? "bico-font bico-Cascadetable" : "bico-font bico-internaltable"
                        },
                        class: "table-icon-common dsh-margin-right5"
                    }),
                    h("span", {
                        class: "table-text-common"
                    }, col._type == "flatTable" ? `${params.row[col._key] ? params.row[col._key].list.length : 0}行` : `${params.row[col._key] ? this.$getTreeLeafTotal(params.row[col._key].tree) : 0} 行`)
                ])]);

            };
        } else if (["editor"].includes(col._type)) {
            col.width = col._width || 110;
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                return h("div", {style: {
                    width: "100%",
                    overflow: "hidden",
                    textAlign: "center"
                }}, [h("span", {
                    style: {
                        display: "inline-block",
                        height: "24px",
                        lineHeight: "24px",
                        padding: "0 5px",
                        margin: "auto",
                        border: `1px solid ${themeColor}`,
                        textAlign: "center",
                        color: themeColor
                    }
                }, [
                    h("span", {
                        class: "table-text-common"
                    }, col.title)
                ])]);

            };
        } else if (["departments"].includes(col._type)) {
            col.titleAlign = "left";
            col.width = col._width || 100;
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                let departStr = "";
                if (params.row[col._key] && params.row[col._key].length > 0) {
                    params.row[col._key].forEach(ele => {
                        departStr += (ele && (ele.name || ele.realname || ele.mobile || ele)) + "，";
                    });
                    departStr = departStr.substring(0, departStr.length - 1);
                }
                return departStr ? h("Ctooltip", {
                    props: {
                        content: departStr,
                        transfer: true
                    }
                }, [
                    h("div", {
                        class: "dsh-ellipsis"
                    }, departStr)
                ]) : departStr;
            };
        } else if (["users"].includes(col._type)) {
            col.titleAlign = "left";
            col.width = col._width || Math.max(titleWidth, 120);
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                // 兼容对对象形势下的处理
                if (this.$dataType(params.row[col._key], "object")) {
                    params.row[col._key] = [params.row[col._key]];
                }
                if (params.row[col._key] && params.row[col._key].length > 0) {
                    return h("div", {
                        class: "dsh-ellipsis",
                        style: {
                            paddingLeft: "5px"
                        }
                    }, params.row[col._key]
                        .filter(item => !!item)
                        .map(item => {
                            return h("img", {
                                attrs: {
                                    src: item.avatarurl || this.$imageSrcMap.system.boy
                                },
                                style: {
                                    width: "18px",
                                    height: "18px",
                                    marginLeft: "-5px",
                                    borderRadius: "50%",
                                    verticalAlign: "middle"
                                }
                            });
                        }).concat(h("span", {
                            style: {
                                width: "18px",
                                height: "18px",
                                verticalAlign: "middle",
                                marginLeft: "7px"
                            }
                        }, params.row[col._key][0] && (params.row[col._key][0].name || params.row[col._key][0].realname || params.row[col._key][0].mobile || params.row[col._key][0])))
                    );
                } else {
                    return "";
                }
            };
        } else if (["reference"].includes(col._type)) {
            col.titleAlign = "left";
            col.align = "left";
            col.width = col._width || 250;
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                if (!params.row[col._key]) {
                    return h("span", "");
                }
                let content = params.row[col._key] && params.row[col._key]._name;
                while (content && content._name) {
                    content = content._name;
                };

                if (Array.isArray(content)) {
                    content = content[0] && content[0].name || "";
                }
                return h("Ctooltip", {
                    props: {
                        placement: "top",
                        transfer: true,
                        content: String(content) || "单条关联"
                    }
                }, [
                    h("span", {
                        style: {
                            height: "24px",
                            lineHeight: 1.6,
                            display: "inline-block",
                            width: "fit-content",
                            maxWidth: "100%",
                            verticalAlign: "middle",
                            margin: "auto",
                            background: "#f2f8ff",
                            border: "1px solid #3DB8C5",
                            borderRadius: "4px",
                            color: themeColor,
                            padding: "0 5px"
                        },
                        class: "dsh-ellipsis"
                    }, [
                        h("Icon", {
                            props: {
                                type: "ios-link"
                            },
                            class: "table-reference-icon"
                        }),
                        h("span", {}, content || "单条关联")
                    ])
                ]);
            };
        } else if (["referenceBy"].includes(col._type)) {
            col.titleAlign = "center";
            col.width = col._width || 100;
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                let count = params.row[col._key] && params.row[col._key].count || 0;
                return h("span", {
                    style: {
                        display: "inline-block",
                        width: "54px",
                        height: "24px",
                        lineHeight: "24px",
                        marginLeft: "50%",
                        transform: "translateX(-50%)",
                        background: "rgba(96, 144, 237, 0.15)",
                        borderRadius: "12px",
                        textAlign: "center",
                        color: themeColor
                    }
                }, [
                    h("Icon", {
                        props: {
                            type: "ios-link"
                        },
                        class: "table-icon-common dsh-margin-right5"
                    }),
                    h("span", {
                        class: "table-text-common"
                    }, `${count}条`)
                ]);
            };
        } else if (["link"].includes(col._type)) {
            col.titleAlign = "left";
            col.width = col._width || Math.max(titleWidth, 100);
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                return h("div", {
                    class: "dsh-ellipsis"
                }, [
                    h("Icon", {
                        props: {
                            type: "ios-link"
                        },
                        class: "table-icon-common dsh-margin-right5"
                    }),
                    h("span", {
                        class: "table-text-common"

                    }, params.row[col._key])
                ]);
            };
        } else if (["render"].includes(col._type)) {
            col.titleAlign = col._titleAlign || "left";
            col.columnAlign = col._columnAlign || "left";
            col.width = col._width || Math.max(titleWidth, 100);
            col.componentName = "dsh-td-render";
            col.render = col._render;
        } else if (["action"].includes(col._type)) {
            col.type = "expane";
            col.isFrozenRight = col._isFrozenRight;
            col.componentName = "dsh-td-render";
            // col.titleAlign = col._titleAlign || "left";
            col.titleAlign = "center";
            col.columnAlign = "center";
            col.render = (h, params) => {
                return h("dsh-buttons", {
                    props: {
                        list: this.$getOperationList(col._list)
                    },
                    on: {
                        click: (operationItem) => {
                            this.$dispatchEvent(operationItem, params);
                        }
                    }
                });
            };

        } else if (["coordinates"].includes(col._type)) {
            col.width = col._width || 110;
            col.columnAlign = "center";
            col.titleAlign = "center";
            col.componentName = "dsh-td-render";
            col.render = (h, params) => {
                return h("div", {style: {
                    width: "100%",
                    overflow: "hidden"
                }}, [h("span", {
                    style: {
                        display: "inline-block",
                        height: "24px",
                        lineHeight: "24px",
                        padding: "0 5px",
                        margin: "auto",
                        background: "rgba(96, 144, 237, 0.15)",
                        borderRadius: "12px",
                        textAlign: "center",
                        color: themeColor
                    }
                }, [
                    h("Icon", {
                        props: {
                            custom: "bico-font bico-position"
                        },
                        style: {
                            fontSize: "18px",
                            color: themeColor
                        }
                    }),
                    h("span", {
                        style: {
                            fontSize: "14px",
                            color: themeColor
                        }
                    }, params.row[col._key] && params.row[col._key].name)
                ])]);

            };
        }

        columns.push(col);
    });
    return columns;
};

const getAppStyle = function (appItem, w) {
    let { themeColors, themeIcons } = this.$appData;
    let colorObj = themeColors[appItem.colorType] || themeColors["color-1"];
    let icon = themeIcons[appItem.iconType] || themeIcons["icon-1"];

    return {
        bg: {
            "background-color": colorObj.color,
            "border-radius": w / 2 + "px",
            "text-align": "center",
            "width": w + "px",
            "height": w + "px",
            "min-width": w + "px",
            "line-height": w + "px"
        },
        icon: "bico-font " + icon,
        iconStyle: {
            color: "#fff"
        }
    };
};

export {
    transformToColumns,
    getAppStyle
};

export default {
    transformToColumns,
    getAppStyle
};



// WEBPACK FOOTER //
// ./src/global/prototype.js